var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SparklesIcon } from '@heroicons/react/24/solid';
import Button from '@web/components/layout/Button';
import { IS_DEMO } from '@web/config';
import { useToast } from '@web/hocs/useToast';
import { trpc } from '@web/lib/trpc';
import { AILabelsResponseSchema } from '@workalizer/generative-ai/src/lib/activityLabels/activityLabelsSchemas';
import { useTranslation } from 'react-i18next';
export default function GenerateLabelsButton(_a) {
    var _this = this;
    var isGenerating = _a.isGenerating, setIsGenerating = _a.setIsGenerating, setGeneratedLabels = _a.setGeneratedLabels, setIsGeneratedLabelsModalVisible = _a.setIsGeneratedLabelsModalVisible;
    var t = useTranslation().t;
    var toast = useToast().toast;
    var getAILabels = trpc.getAILabels.useMutation();
    var handleGenerateLabels = function () { return __awaiter(_this, void 0, void 0, function () {
        var generatedLabels, parsedLabels, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (IS_DEMO) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsGenerating(true);
                    return [4 /*yield*/, getAILabels.mutateAsync()];
                case 2:
                    generatedLabels = _a.sent();
                    parsedLabels = AILabelsResponseSchema.safeParse(generatedLabels);
                    if (!parsedLabels.success) {
                        toast({
                            title: t('app.settings.activityLabels.errorGeneratingLabels'),
                            variant: 'error',
                            duration: 3000
                        });
                        return [2 /*return*/];
                    }
                    if (parsedLabels.data.length > 0) {
                        setGeneratedLabels(parsedLabels.data);
                        setIsGeneratedLabelsModalVisible(true);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    toast({
                        title: t('app.settings.activityLabels.errorGeneratingLabels'),
                        variant: 'error',
                        duration: 3000
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setIsGenerating(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Button, __assign({ variant: "primary", onClick: handleGenerateLabels, disabled: isGenerating, className: "flex items-center gap-2" }, { children: [_jsx(SparklesIcon, { className: "h-5 w-5 ".concat(isGenerating ? 'animate-spin' : '') }), isGenerating
                ? t('app.settings.activityLabels.generating')
                : t('app.settings.activityLabels.generateByAI')] })));
}
